// src/api.js

const BASE = process.env.REACT_APP_API_BASE_URL || '/api';

/* ===============================
   FETCH WRAPPER (NO QUITAR)
================================ */

async function apiFetch(url, options = {}) {
  let response;

  try {
    response = await fetch(url, {
      ...options,
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        ...(options.headers || {})
      }
    });
  } catch (networkError) {
    console.warn('Error de red:', url, networkError);
    return { success: false, data: [] };
  }

  const text = await response.text();

  if (!text) {
    console.warn('Respuesta vacía:', url);
    return { success: false, data: [] };
  }

  let data;
  try {
    data = JSON.parse(text);
  } catch {
    console.warn('Respuesta NO JSON:', url);
    console.warn(text.slice(0, 200));
    return { success: false, data: [] };
  }

  if (!response.ok) {
    console.warn(`HTTP ${response.status}:`, url, data);
    return {
      success: false,
      message: data.message || 'Error de servidor',
      data: []
    };
  }

  return data;
}

/* ===============================
   AUTENTICACIÓN
================================ */

export function login({ username, password }) {
  return fetch(`${BASE}/login.php`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({ username, password })
  }).then(async res => {
    const text = await res.text();
    if (!text) return { success: false };
    try {
      const data = JSON.parse(text);
      if (data.success && data.data?.user) {
        localStorage.setItem("user", JSON.stringify(data.data.user));
      }
      return data;
    } catch {
      return { success: false };
    }
  });
}

export function logout() {

  localStorage.removeItem("user");

  return apiFetch(`${BASE}/logout.php`, { method: 'POST' });
}

export function getCurrentUser() {
  return apiFetch(`${BASE}/me.php`);
}

/* ===============================
   CATEGORÍAS
================================ */

export function getCategories() {
  return apiFetch(`${BASE}/list_categories.php`);
}

export function createCategory(category) {
  return apiFetch(`${BASE}/create_category.php`, {
    method: 'POST',
    body: JSON.stringify(category)
  });
}

export function deleteCategory(id) {
  return apiFetch(`${BASE}/delete_category.php`, {
    method: 'POST',
    body: JSON.stringify({ id })
  });
}

/* ===============================
   PRODUCTOS
================================ */

export function getMenuItems(categoryId = null) {
  let url = `${BASE}/list_products.php`;
  if (categoryId !== null) url += `?category_id=${categoryId}`;
  return apiFetch(url);
}

export function createMenuItem(item) {

  const formData = new FormData();

  formData.append('name', item.name);
  formData.append('categoryId', item.categoryId);
  formData.append('price', item.price);
  formData.append('priceWithoutVAT', item.priceWithoutVAT);

  // 🔥 SOPORTE DOBLE
  if (item.image instanceof File) {
    formData.append('image', item.image);
  } else if (item.image) {
    formData.append('image_url', item.image);
  }

  return fetch(`${BASE}/create_menu_item.php`, {
    method: 'POST',
    body: formData
  }).then(res => res.json());
}

export function updateMenuItem(item) {

  const formData = new FormData();

  formData.append('id', item.id);
  formData.append('name', item.name);
  formData.append('categoryId', item.categoryId);
  formData.append('price', item.price);
  formData.append('priceWithoutVAT', item.priceWithoutVAT);

  if (item.image instanceof File) {
    formData.append('image', item.image);
  } else if (item.image) {
    formData.append('image_url', item.image);
  }

  return fetch(`${BASE}/update_product.php`, {
    method: 'POST',
    body: formData
  }).then(res => res.json());
}

export function deleteMenuItem(id) {
  return apiFetch(`${BASE}/delete_product.php`, {
    method: 'POST',
    body: JSON.stringify({ id })
  });
}

/* ===============================
   INSUMOS
================================ */

export function getSupplies() {
  return apiFetch(`${BASE}/list_supplies.php`);
}

export function createSupply(supply) {
  return apiFetch(`${BASE}/create_supply.php`, {
    method: 'POST',
    body: JSON.stringify(supply)
  });
}

export function updateSupply(supply) {
  return apiFetch(`${BASE}/update_supply.php`, {
    method: 'POST',
    body: JSON.stringify(supply)
  });
}

export function deleteSupply(id) {
  return apiFetch(`${BASE}/delete_supply.php`, {
    method: 'POST',
    body: JSON.stringify({ id })
  });
}

/* ===============================
   RECETAS
================================ */

export function getRecipes() {
  return apiFetch(`${BASE}/list_recipes.php`);
}

export function createRecipe(recipe) {
  return apiFetch(`${BASE}/save_recipe.php`, {
    method: 'POST',
    body: JSON.stringify(recipe)
  });
}

export function updateRecipe(recipe) {
  return apiFetch(`${BASE}/update_recipe.php`, {
    method: 'POST',
    body: JSON.stringify(recipe)
  });
}

export function deleteRecipe(id) {
  return apiFetch(`${BASE}/delete_recipe.php`, {
    method: 'POST',
    body: JSON.stringify({ id })
  });
}

/* ===============================
   ORDENES / POS
================================ */

export function createOrder(orderData) {

  let user = null;

  try {
    user = JSON.parse(localStorage.getItem("user"));
  } catch (e) {
    console.warn("No se pudo leer el usuario del localStorage");
  }

  const payload = {
    items: orderData.items || orderData.cart || [],
    payment_method: orderData.payment_method || "Efectivo",
    total: orderData.total || 0,
    user_id: user?.id || user?.user_id || null
  };

  console.log("Usuario POS:", user);
  console.log("Enviando venta:", payload);

  return apiFetch(`${BASE}/create_order.php`, {
    method: 'POST',
    body: JSON.stringify(payload)
  }).then(res => {

    if (res.success) {
      console.log("Orden creada:", res);
    } else {
      console.warn("Error creando orden:", res);
    }

    return res;
  });
}

/* ===============================
   COMANDAS
================================ */

export function listOrders() {
  return apiFetch(`${BASE}/list_orders.php`);
}

export function updateOrderStatus(orderId, status) {
  return apiFetch(`${BASE}/update_order_status.php`, {
    method: 'POST',
    body: JSON.stringify({ order_id: orderId, status })
  });
}

/* ===============================
   VENTAS (HISTORIAL / CAJA)
================================ */

export function getSales() {
  return apiFetch(`${BASE}/list_sales.php`);
}

export function getManualSales() {
  return apiFetch(`${BASE}/list_manual_sales.php`);
}

export function registerSale(payload) {
  return apiFetch(`${BASE}/register_sale.php`, {
    method: 'POST',
    body: JSON.stringify(payload)
  });
}

export function updateSaleStatus(id, status) {
  return apiFetch(`${BASE}/update_sale_status.php`, {
    method: 'POST',
    body: JSON.stringify({ id, status })
  });
}

/* ===============================
   EMPLEADOS
================================ */

export function getEmployees() {
  return apiFetch(`${BASE}/list_employees.php`);
}

export function createEmployee(employee) {
  return apiFetch(`${BASE}/create_employee.php`, {
    method: 'POST',
    body: JSON.stringify(employee)
  });
}

export function updateEmployee(employee) {
  return apiFetch(`${BASE}/update_employee.php`, {
    method: 'POST',
    body: JSON.stringify(employee)
  });
}

export function deleteEmployee(id) {
  return apiFetch(`${BASE}/delete_employee.php`, {
    method: 'POST',
    body: JSON.stringify({ id })
  });
}

/* ===============================
   ASISTENCIA
================================ */

export function registerAttendance(payload) {
  return apiFetch(`${BASE}/register_attendance.php`, {
    method: 'POST',
    body: JSON.stringify(payload)
  });
}

export function getAttendance() {
  return apiFetch(`${BASE}/list_attendance.php`);
}

/* ===============================
   GESTIÓN DE CAJA
================================ */

export function openCashDrawer(payload) {
  return apiFetch(`${BASE}/open_cash_drawer.php`, {
    method: 'POST',
    body: JSON.stringify(payload)
  });
}

export function closeCashDrawer(payload) {
  return apiFetch(`${BASE}/close_cash_drawer.php`, {
    method: 'POST',
    body: JSON.stringify(payload)
  });
}

export function getActiveCashDrawer() {
  return apiFetch(`${BASE}/get_active_cash_drawer.php`);
}

/* 🔥 HISTORIAL (CORRECTO) */
export function getCashDrawersHistory() {
  return apiFetch(`${BASE}/get_cash_drawers_history.php`);
}
/* ===============================
   CATEGORÍAS DE INSUMO
================================ */

export function getSupplyCategories() {
  return apiFetch(`${BASE}/list_supply_categories.php`);
}

export function createSupplyCategory(category) {
  return apiFetch(`${BASE}/create_supply_category.php`, {
    method: 'POST',
    body: JSON.stringify(category)
  });
}

export function deleteSupplyCategory(id) {
  return apiFetch(`${BASE}/delete_supply_category.php`, {
    method: 'POST',
    body: JSON.stringify({ id })
  });
}

/* ===============================
   INVENTARIO (NUEVO SISTEMA)
================================ */

export function getInventory() {
  return apiFetch(`${BASE}/list_inventory.php`);
}

export function updateInventory(payload) {
  return apiFetch(`${BASE}/update_inventory.php`, {
    method: 'POST',
    body: JSON.stringify(payload)
  });
}

export function addInventoryMovement(payload) {
  return apiFetch(`${BASE}/add_inventory_movement.php`, {
    method: 'POST',
    body: JSON.stringify(payload)
  });
}

export function getInventoryMovements() {
  return apiFetch(`${BASE}/list_inventory_movements.php`);
}